import qlMuscleRevealPNG from '~/assets/images/anatomyV2/ql-muscle-reveal.png'
import qlMuscleRevealWEBP from '~/assets/images/anatomyV2/ql-muscle-reveal.webp'
import InfoRevealTemplate from '~/pages/anatomyV2/libs/components/InfoRevealTemplate'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 1

const QlMuscleRevealAnatomyV2 = (props: TPageProps) => (
  <InfoRevealTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    imageAlt="Quadratus lumborum muscle"
    imagePNG={qlMuscleRevealPNG}
    imageWEBP={qlMuscleRevealWEBP}
    isCompactImage
    paragraphI18nKeys={[
      'onboarding.qlMuscleReveal.paragraphFirst',
      'onboarding.qlMuscleReveal.paragraphSecond',
    ]}
    question="QL muscle reveal viewed"
    titleI18nKey="onboarding.qlMuscleReveal.title"
  />
)

export default QlMuscleRevealAnatomyV2
